const AV_date = Cookies.get('AV_date');

if ( AV_date !== undefined  ){

    var strArray = AV_date.split("-");
    var xy = strArray[0];
    var xm = parseInt(strArray[1]);
    xm = xm - 1;
    var xd = strArray[2];

    var setDate = new Date(xy,xm,xd);
    setDate = dateFormat(setDate,"isoDate");
}

$( document ).ready(function() {
    var close_element = document.getElementById('discount-close');

    var $dpContent = $('#dp-content');

    if(!$dpContent.length)
        return;

    $.validator.addMethod("minAge", function(value, element, min) {
        var today = new Date();
        var birthDate = new Date(value);
        var age = today.getFullYear() - birthDate.getFullYear();

        if (age > min+1) {
            return true;
        }

        var m = today.getMonth() - birthDate.getMonth();

        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }

        return age >= min;
    }, "You must be of legal drinking age.");


    $.validator.addMethod("emailwdomain", function(value, element) {
        return this.optional(element) || /^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/.test(value) || /[-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?/.test(value);
    }, "Please enter a valid email address.");

    function setWithExpiry(key, value, ttl) {

        const now = new Date()

        // `item` is an object which contains the original value
        // as well as the time when it's supposed to expire
        const item = {
            value: value,
            expiry: now.getTime() + ttl,
        }
        localStorage.setItem(key, JSON.stringify(item))
    }

    function getUrlParameterByName(name) {
        var vars = {};
        var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
            vars[key] = value;
        });
        return vars[name];
    }

    if (getUrlParameterByName('noPop') == 'true') {
        setWithExpiry('hide_discount', 'true', 604800000);
    }

    function getWithExpiry(key) {
        const itemStr = localStorage.getItem(key)
        // if the item doesn't exist, return null
        if (!itemStr) {
            return null
        }
        const item = JSON.parse(itemStr)
        const now = new Date()
        // compare the expiry time of the item with the current time
        if (now.getTime() > item.expiry) {
            // If the item is expired, delete the item from storage
            // and return null
            localStorage.removeItem(key)
            return null
        }
        return item.value
    }


    var btn_pop = document.getElementById('shopify-section-discount-popup');
    var btn_pop_ico = document.getElementById('discount-close');
    var annoucement_bar_trigger = document.getElementsByClassName('announcement-bar--trigger');

    function hideDiscount(){
        btn_pop.style.display = "none";
        setWithExpiry('hide_discount', 'true', 604800000);
        localStorage.removeItem('dp-success');
        //hide for 1 week
    }

    btn_pop_ico.addEventListener('click', function () {
        hideDiscount();
    });

    document.addEventListener('keyup', function(e) {
        if (e.key === "Escape") {
            hideDiscount();
        }
    });

    function tabbing () {
        setTimeout(()=>{
            close_element.focus();
            let discount_popup = $('#discount-popup');
            $('#discount-popup').on('keydown', function (evt){
                let first_step = $('#discount-popup').find('#first-step');
                let second_step =$('#discount-popup').find('#ContactFormEmail');
                let third_step =$('#discount-popup').find('.thank-you');
                const lastElement = $('#discount-popup').find('.last-elem');
                if (evt.shiftKey && evt.keyCode === 9) {
                    if((first_step.length > 0) && (typeof first_step !== 'undefined') && (first_step !== null)) {
                        if($(evt.target).hasClass('fa-times')) {
                            lastElement.focus();
                        }
                    }
                    if((second_step.length > 0) && (typeof second_step !== 'undefined') && (second_step !== null)) {
                        if($(evt.target).hasClass('fa-times')) {
                            lastElement.focus();
                        }
                    }
                    if((third_step.length > 0) && (typeof third_step !== 'undefined') && (third_step !== null)) {
                        lastElement.focus();
                    }
                } else if ((evt.keyCode == 9)) {
                    if((first_step.length > 0) && (typeof first_step !== 'undefined') && (first_step !== null)){
                        if($(evt.target).hasClass('dp-button')) {
                            discount_popup.focus();
                         }
                    }
                    if((second_step.length > 0) && (typeof second_step !== 'undefined') && (second_step !== null)){
                        if($(evt.target).hasClass('legal-text') ) {
                            discount_popup.focus();
                         }
                    }
                    if((third_step.length > 0) && (typeof third_step !== 'undefined') && (third_step !== null)){
                        discount_popup.focus();
                    }
                }
                lastElement.length > 0 ? "" : $("#dp-content").append('<p class="last-elem" aria-hidden="true" tabindex="0"></p>');
            })
        },500)
    }

    if (getWithExpiry('hide_discount') !== 'true') {
        btn_pop.style.display = 'block';
        setTimeout(function (){
            window.scrollTo(0, 0);
            $(this).scrollTop(0);
            tabbing();
        }, 500)
        if (localStorage.getItem('dp-success') == 'true') {
            $dpContent.html(window.dp.thirdStep);
            tabbing();
        }
    }

    for (var i = 0; i < annoucement_bar_trigger.length; i++) {
        annoucement_bar_trigger[i].addEventListener('click', function (){
            localStorage.removeItem('hide_discount');
            btn_pop.style.display = 'block';
        }, false)
    }

    $("#first-step").validate({
        rules: {
            'dp-email': {
                emailwdomain: true
            }
        }
    });
    $('#first-step .dp-button').on('click', function() {
        if($("#first-step").valid()) {
            let email = $('#dp-email').val();
            $dpContent.html(window.dp.secondStep);
            tabbing();
            $('#ContactFormEmail').attr('value', email);
            $("#discount-popup .shadow-form__discount-popup").validate({
                rules: {
                    'email': {
                        emailwdomain: true
                    },
                    'dob': {
                        required: true,
                        minAge: 21
                    },
                    'dp-email': {
                        emailwdomain: true
                    }
                },
                submitHandler: function(form) {
                    let firstName = $('.sfn-first-name').val();
                    let lastName = $('.sfn-last-name').val();
                    let zipCode = $('.sfn-zip-code').val();
                    let phoneNumber = $('.sfn-phone').val();
                    let dob = $('.sfn-dob').val();
                    $('#FirstName').val( firstName);
                    $('#LastName').val( lastName);
                    $('#c_zip').val( zipCode);
                    $('#ContactFormPhone').val(phoneNumber);
                    $('#dateofbirthDiscountPop').val(dob);

                    localStorage.setItem('dp-success', 'true');
                    let dobfield = document.getElementById('dateofbirthDiscountPop').value;
                    Cookies.set('AV_date', dobfield, {expires: 1, path: '/'})
                    const myForm = document.getElementById('contact_form');
                    window.Shopify.captcha.protect(myForm, () => {
                        myForm.submit();
                    });
                }
            });
            if (setDate !== undefined || setDate !== null) {
                var dateControl = document.getElementById('dateofbirthDiscountPop');
                if (dateControl !== null) {
                    dateControl.value = setDate;

                }
            }
        }
    });

});

